import { useQuery } from '@tanstack/react-query';

import { getTheme } from '../../services';

export const useGetTheme = (_params, options = {}) =>
  useQuery(['getTheme'], getTheme, {
    staleTime: Infinity,
    ...options
  });
